import { useState } from 'react';

import { useInstanceCallback } from '@/scenarios/legacy-player/hooks/useInstanceCallback';
import { useInstanceEffect } from '@/scenarios/legacy-player/hooks/useInstanceEffect';
import { usePlayerInstance } from '@/scenarios/legacy-player/lib/contexts/instance';

export const useMute = () => {
    const instance = usePlayerInstance();
    const [isMuted, setIsMuted] = useState<boolean>(() => Boolean(instance?.isMuted));

    const toggleMute = useInstanceCallback((instance) => instance?.setIsMuted(!isMuted), [isMuted]);

    useInstanceEffect((instance) => {
        const unsubscribe = instance.onMuteChange(setIsMuted);
        setIsMuted(Boolean(instance?.isMuted));
        return unsubscribe;
    });

    return { isMuted, toggleMute };
};
